export enum FileUploadStatus {
  NOT_SENT_YET = 'NOT_SENT_YET',
  SENT = 'SENT',
  UPLOADING = 'UPLOADING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
